module.exports = __webpack_public_path__ + "static/media/ADDVA_PRITOU.94038bc4.svg";